import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid'
import Tooltip from '../../../UI/Tooltip/Tooltip'

const Description = ({ text, leftAlign = false }) => {
  if (!text) return null
  return (
    <div>
      <Tooltip text={text} leftAlign={leftAlign} classNameInner={'bg-black'}>
        <QuestionMarkCircleIcon className="w-4 h-4 fill-black" />
      </Tooltip>
    </div>
  )
}

export default Description
